import { ROUTES } from '../../Lib/constants';
import vars from '../../theme/vars';
import { PasswordScreen } from './PasswordScreen';
import { PasswordScreenSA } from './PasswordScreenSA';

const { headings } = vars;
export default {
  [ROUTES.password.name]: {
    screen: PasswordScreen,
  },
  [ROUTES.passwordSA.name]: {
    screen: PasswordScreenSA,
  },
};
